
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { Observer } from 'mobx-vue'
import { EnumMyAccountMenu } from '@xt/client/enums/my'

@Observer
@Component({
  components: {
    InfiniteLoading
  }
})
export default class MyAccountBishan extends Vue {
  get pagePagination() {
    return this.$store.$myV2.Account.BiShan.pagePagination
  }

  get PageStore() {
    return this.$store.$myV2.Account.BiShan
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  @Emit('change-menu')
  goExchange() {
    return EnumMyAccountMenu.Exchange
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
